import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { EditorPropertyMenuKey } from '../editor-property-panel/types/types';

export interface AiVideoModalState {
  isOpen: boolean;
  imageUrl: string;
}

interface PropertyPanelContextType {
  activeMenu: EditorPropertyMenuKey | null;
  setActiveMenu: (menu: EditorPropertyMenuKey | null) => void;
  openAssetPanel: () => void;
  aiVideoModalState: AiVideoModalState | null;
  setAiVideoModalState: (state: AiVideoModalState | null) => void;
}

const defaultPropertyPanelContext: PropertyPanelContextType = {
  activeMenu: null,
  setActiveMenu: () => {},
  openAssetPanel: () => {},
  aiVideoModalState: null,
  setAiVideoModalState: () => {},
};

const PropertyPanelContext = createContext<PropertyPanelContextType>(
  defaultPropertyPanelContext,
);

interface PropertyPanelProviderProps {
  children: ReactNode;
}

export const PropertyPanelProvider = ({
  children,
}: PropertyPanelProviderProps) => {
  const [activeMenu, setActiveMenu] =
    useState<PropertyPanelContextType['activeMenu']>(null);

  const [aiVideoModalState, setAiVideoModalState] =
    useState<AiVideoModalState | null>(null);

  const openAssetPanel = useCallback(() => {
    setActiveMenu('asset');
  }, []);

  const value = useMemo(
    () => ({
      activeMenu,
      setActiveMenu,
      openAssetPanel,
      aiVideoModalState,
      setAiVideoModalState,
    }),
    [activeMenu, openAssetPanel, aiVideoModalState],
  );

  return (
    <PropertyPanelContext.Provider value={value}>
      {children}
    </PropertyPanelContext.Provider>
  );
};

export const usePropertyPanelContext = () => {
  return useContext(PropertyPanelContext);
};
